"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frassilongo": {
    "6d9fc9bc": [{
      "hkey": "2c329f22",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "frassilongo-inderpergh": [{
      "hkey": "2c329f22",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0bb2b3fb": [{
      "hkey": "2fdb56b0",
      "slug": "roveda",
      "name": "Roveda",
      "primary": true,
      "skipSearch": false
    }],
    "mitterpergh": [{
      "hkey": "2fdb56b0",
      "slug": "roveda",
      "name": "Roveda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "frassilongo"
    }],
    "834d9a81": [{
      "hkey": "1b4cffc5",
      "slug": "frassilongo",
      "name": "Frassilongo",
      "primary": true,
      "skipSearch": false
    }],
    "oeberpergh": [{
      "hkey": "1b4cffc5",
      "slug": "frassilongo",
      "name": "Frassilongo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2f6cfa8": [{
      "hkey": "2fdb56b0",
      "slug": "roveda",
      "name": "Roveda",
      "primary": true,
      "skipSearch": false
    }],
    "roveda-unterpergh": [{
      "hkey": "2fdb56b0",
      "slug": "roveda",
      "name": "Roveda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;